import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70a6b330"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = { class: "flex gap-4" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["onClick", "disabled"]
const _hoisted_6 = { class: "flex gap-4" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]

import { computed } from 'vue';

interface Props {
  maxVisibleButtons?: number;
  totalPages: number;
  perPage: number;
  currentPage: number;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    maxVisibleButtons: { default: 3 },
    totalPages: null,
    perPage: null,
    currentPage: null
  },
  emits: ["page-changed"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'page-changed', page: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { maxVisibleButtons: number, totalPages: number, perPage: number, currentPage: number }





const startPage = computed(() => {
  if (props.currentPage === 1) return 1;
  if (props.currentPage === props.totalPages) {
    return props.totalPages - props.maxVisibleButtons;
  }
  return props.currentPage - 1;
});

const pages = computed(() => {
  const range = [];

  for (
    let i = startPage.value;
    i <=
    Math.min(startPage.value + props.maxVisibleButtons - 1, props.totalPages);
    i++
  ) {
    range.push({
      name: i,
      isDisabled: i === props.currentPage,
    });
  }

  return range;
});

const isInFirstPage = computed(() => props.currentPage === 1);
const isInLastPage = computed(() => props.currentPage === props.totalPages);

function onClickFirstPage() {
  emit('page-changed', 1);
}

function onClickPreviousPage() {
  emit('page-changed', props.currentPage - 1);
}

function onClickPage(page: number) {
  emit('page-changed', page);
}

function onClickNextPage() {
  emit('page-changed', props.currentPage + 1);
}

function onClickLastPage() {
  emit('page-changed', props.totalPages);
}

return (_ctx: any,_cache: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          title: "First",
          type: "button",
          onClick: onClickFirstPage,
          disabled: _unref(isInFirstPage)
        }, [
          _createVNode(_component_fa_icon, { icon: "step-backward" })
        ], 8, _hoisted_3)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          title: "Previous",
          type: "button",
          onClick: onClickPreviousPage,
          disabled: _unref(isInFirstPage)
        }, [
          _createVNode(_component_fa_icon, { icon: "backward" })
        ], 8, _hoisted_4)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pages), (page) => {
      return (_openBlock(), _createElementBlock("li", {
        key: page.name
      }, [
        _createElementVNode("button", {
          type: "button",
          onClick: ($event: any) => (onClickPage(page.name)),
          disabled: page.isDisabled
        }, _toDisplayString(page.name), 9, _hoisted_5)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          title: "Next",
          type: "button",
          onClick: onClickNextPage,
          disabled: _unref(isInLastPage)
        }, [
          _createVNode(_component_fa_icon, { icon: "forward" })
        ], 8, _hoisted_7)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          title: "Last",
          type: "button",
          onClick: onClickLastPage,
          disabled: _unref(isInLastPage)
        }, [
          _createVNode(_component_fa_icon, { icon: "step-forward" })
        ], 8, _hoisted_8)
      ])
    ])
  ]))
}
}

})